module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Acknowledgement"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction"
    }
  }, [_vm._v("Introduction / "), _c('i', [_vm._v("Rielle Navitski and Nicolas Poppe")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Part01"
    }
  }, [_vm._v("Part I. The Silent Era: "), _c('i', [_vm._v("Between Global Capitalism and National Modernization")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chaptera"
    }
  }, [_vm._v("Primary text: “The Lumière Cinematograph,” "), _c('i', [_vm._v("El Monitor Republicano")]), _vm._v(" (Mexico City), August 16, 1896")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter01"
    }
  }, [_vm._v("1 Gabriel Veyre and Fernand Bon Bernard, Representatives of the Lumière Brothers in Mexico "), _c('i', [_vm._v("/ Aurelio de los Reyes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14_Chapterb"
    }
  }, [_vm._v("Primary text: Tic-Tac (Carlos Villafañe), “The Show on June 15th,” "), _c('i', [_vm._v("Películas")]), _vm._v(" (Bogotá), June 1919")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Films on Paper: Early Colombian Cinema Periodicals, 1916–1920 "), _c('i', [_vm._v("/ Juan Sebastián Ospina León")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapterc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Primary text: Enrique Méndez Calzada, “The Lover of Rudolph Valentino,” from "), _c('i', [_vm._v("And Christ Returned to Buenos Aires")]), _vm._v(" (1926)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Manipulation and Authenticity: The Unassimilable Valentino in 1920s Argentina "), _c('i', [_vm._v("/ Giorgio Bertellini")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II. The Interwar Period: "), _c('i', [_vm._v("Between Hollywood and the Avant-Garde")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapterd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Primary text: Felipe de Leiva, “Memoirs of an Extra,” "), _c('i', [_vm._v("Cinelandia")]), _vm._v(" (Hollywood), November–December 1927")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Mediating the “Conquering and Cosmopolitan Cinema”: US Spanish-Language Film Magazines and Latin American Audiences, 1916–1948 "), _c('i', [_vm._v("/ Rielle Navitski")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chaptere",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Primary text: Octávio de Faria, “Russian Cinema and Brazilian Cinema,” "), _c('i', [_vm._v("O Fan")]), _vm._v(" (Rio de Janeiro), October 1928")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Parallel Modernities?: The First Reception of Soviet Cinema in Latin America "), _c('i', [_vm._v("/ Sarah Ann Wells")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapterf",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Primary text: Guillermo de Torre, “The ‘Cineclub’ of Buenos Aires,” "), _c('i', [_vm._v("La Gaceta Literaria")]), _vm._v(" (Madrid), April 1, 1930")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 A Gaze Turned Toward Europe: Modernity and Tradition in the Work of Horacio Coppola "), _c('i', [_vm._v("/ Andrea Cuarterolo")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III. The Golden Age of Latin American Film Industries: "), _c('i', [_vm._v("Negotiating the Popular and the Cosmopolitan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapterg",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Primary text: John Alton, “Motion Picture Production in South America,” "), _c('i', [_vm._v("International Photographer")]), _vm._v(" (Hollywood), May 1934")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 John Alton in Argentina, 1932–1939 "), _c('i', [_vm._v("/ Nicolas Poppe")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The Golden Age Otherwise: Mexican Cinema and the Mediations of Capitalist Modernity in the 1940s and 1950s "), _c('i', [_vm._v("/ Ignacio M. Sánchez Prado")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapterh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Primary text: Gabriel García Márquez, “The Mambo,” "), _c('i', [_vm._v("El Heraldo")]), _vm._v(" (Barranquilla), January 12, 1951")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Bad Neighbors: Pérez Prado, Cinema, and the Politics of Mambo "), _c('i', [_vm._v("/ Jason Borge")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV. The Afterlives of Moving Images: "), _c('i', [_vm._v("Cinephilia and Cult Spectatorship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapteri",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Primary text: Thomas E. Sibert, “Fox Film de Cuba, S.A.’s Continuing Competition for Scholarships to Summer School at the Universidad de La Habana” (unpublished circular, June 1956)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Film Culture and Education in Republican Cuba: The Legacy of José Manuel Valdés-Rodríguez "), _c('i', [_vm._v("/ Irene Rozsa")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Secret History of Aztlán: Speculative Histories, Transnational Exploitation Film, and Unexpected Cultural Flows "), _c('i', [_vm._v("/ Colin Gunckel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663ecc01","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Contents.vue
// module id = 75
// module chunks = 0